import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Main from './Main';
import './index.css';
import { Provider } from 'react-redux';
import store from './store/appStore';
import { BrowserRouter } from 'react-router-dom';
import { JssProvider } from 'react-jss';
import { create as createJss } from 'jss';
import preset from 'jss-preset-default';
import ThemeProvider from './theming/ThemeProvider';

import { getMaintenanceState, getMaintenanceConfig } from 'src/utils/maintenance';
import MaintenancePage from 'src/components/pages/MaintenancePage/MaintenancePage';

// Import nvd3 css
import 'nvd3/build/nv.d3.min.css';

// Import react grid layout css
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

// Global responsive overrides for Ant Design modals and drawers
import 'src/design-system/responsive-overrides.css';

declare let window: any;
declare var module: any;
const localJss = createJss({
  ...preset(),
});
const launchApp = (Component: any) => {
  ReactDOM.render(
    <Provider store={store}>
      <JssProvider jss={localJss}>
        <ThemeProvider>
          <BrowserRouter>
            <Component />
          </BrowserRouter>
        </ThemeProvider>
      </JssProvider>
    </Provider>
    ,
    document.getElementById('root') as HTMLElement,
  );
};

const launchMain = () => launchApp(Main);

const launchMaintenance = () => {
  const config = getMaintenanceConfig();
  ReactDOM.render(
    <MaintenancePage config={config} />,
    document.getElementById('root') as HTMLElement,
  );
};

const launch = () => {
  const maintenanceState = getMaintenanceState();
  if (maintenanceState === 'active') {
    launchMaintenance();
  } else {
    launchMain();
  }
};

if (!window.cordova) {
  launch();
} else {
  document.addEventListener('deviceready', launch, false);
}

// Register service worker
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/sw.js').then((worker) => {
//   });
// }

if (module.hot && process.env.NODE_ENV !== 'production') {
  // module.hot.accept();
  module.hot.accept('./Main', () => {
    const NextApp = require('./Main').default;
    launchApp(NextApp);
  });
}
